// Code review - In Progress
// Documentation - In Progress

import { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { BindAPI } from "../services/APIConnection";
import RoleVsCapabilityTable from "../components/RoleVsCapabilityTable";
import * as XLSX from "sheetjs-style";
import toast from "react-hot-toast";

const RoleVsCapabilityTwo = () => {
  const [bindMenuMasterDatas, setBindMenuMasterDatas] = useState([]);
  const [bindRoleVsCapRightsDatas, setBindRoleVsCapRightsDatas] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");
  const [selectedRoleName, setSelectedRoleName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [bindRoleDD, setBindRoleDD] = useState([]);


  useEffect(() => {
    const bindRoleDD = async () => {
      setIsLoading(true);
      const response = await BindAPI("RoleAPI/GetRole");
      const getRoleId =
        response.data.Table && response.data.Table.length > 0
          ? response.data.Table.map((item) => ({
            value: item.MstRoleId,
            label: item.RoleName,
          }))
          : [];
      setBindRoleDD(getRoleId);
      setIsLoading(false);
    };

    bindRoleDD();

  }, []);
  useEffect(() => {
    const getMenuTableDatas = async () => {
      setIsLoading(true);
      const rightsResponse = await BindAPI(
        "RoleVsCapabilityAPI/BindRoleVsCapability"
      );
      setBindRoleVsCapRightsDatas(rightsResponse.data.Table);

      const response = await BindAPI("RoleVsCapabilityAPI/BindScreenMenu");
      const organizedData = {};

      const processMenuData = (menuHeadingId) => {
        const filteredData = response.data.Table.filter(
          (item) => item.MstMenuHeadingId === menuHeadingId
        );

        const menuList = {};

        filteredData.forEach((item) => {
          if (!menuList[item.MenuName]) {
            menuList[item.MenuName] = {
              MenuName: item.MenuName,
              MstMenuId: item.MainMenuId ? null : item.MstMenuId,
              MainMenuId: item.MainMenuId,
              MstMenuHeadingId: item.MstMenuHeadingId,
              checked:
                item.MainMenuId && item.SubMenu && item.SubMenu.length > 0
                  ? null
                  : [],
              SubMenu: [],
              View: item.View,
              Add: item.Add,
              Edit: item.Edit,
              Delete: item.Delete,
              Inactive: item.Inactive,
              Service: item.Service,
            };
          }

          const submenuFiltered = response.data.Table.filter(
            (subItem) =>
              subItem.MenuName === item.MenuName &&
              subItem.MainMenuId &&
              subItem.MstMenuHeadingId === menuHeadingId
          ).map((subItem) => ({
            SubMenu: subItem.SubMenu,
            MstMenuId: subItem.MstMenuId,
            MainMenuId: subItem.MainMenuId,
            checked: [],
            View: item.View,
            Add: item.Add,
            Edit: item.Edit,
            Delete: item.Delete,
            Inactive: item.Inactive,
            Service: item.Service,
          }));

          const arr = rightsResponse.data.Table.filter(
            (e) =>
              e.MstMenuId == menuList[item.MenuName].MstMenuId &&
              e.MstRoleId == selectedRole
          );
          const checkedData =
            arr.length > 0
              ? {
                add: arr[0].AddPermission === 1,
                view: arr[0].ViewPermission === 1,
                inActive: arr[0].BlockPermission === 1,
                delete: arr[0].DeletePermission === 1,
                edit: arr[0].ModifyPermission === 1,
                service: arr[0].ProvideServicePermission === 1,
                title:
                  arr[0].AddPermission === 1 &&
                  arr[0].ViewPermission === 1 &&
                  arr[0].BlockPermission === 1 &&
                  arr[0].DeletePermission === 1 &&
                  arr[0].ModifyPermission === 1 &&
                  arr[0].ProvideServicePermission === 1,
              }
              : {
                title: false,
                add: false,
                view: false,
                inActive: false,
                delete: false,
                edit: false,
                service: false,
              };
          if (menuList[item.MenuName].checked !== null) {
            menuList[item.MenuName].checked.push(checkedData);
          }

          submenuFiltered.forEach((subItem) => {
            const subMenuItemExists = menuList[item.MenuName].SubMenu.some(
              (existingSubMenu) => existingSubMenu.SubMenu == subItem.SubMenu
            );
            if (!subMenuItemExists) {
              const arr = rightsResponse.data.Table.filter(
                (e) =>
                  e.MstMenuId == subItem.MstMenuId &&
                  e.MstRoleId == selectedRole
              );
              subItem.checked =
                arr.length > 0
                  ? {
                    add: arr[0].AddPermission === 1,
                    view: arr[0].ViewPermission === 1,
                    inActive: arr[0].BlockPermission === 1,
                    delete: arr[0].DeletePermission === 1,
                    edit: arr[0].ModifyPermission === 1,
                    service: arr[0].ProvideServicePermission === 1,
                    title:
                      arr[0].AddPermission === 1 &&
                      arr[0].ViewPermission === 1 &&
                      arr[0].BlockPermission === 1 &&
                      arr[0].DeletePermission === 1 &&
                      arr[0].ModifyPermission === 1 &&
                      arr[0].ProvideServicePermission === 1,
                  }
                  : {
                    title: false,
                    add: false,
                    view: false,
                    inActive: false,
                    delete: false,
                    edit: false,
                    service: false,
                  };

              if (!subMenuItemExists) {
                menuList[item.MenuName].SubMenu.push(subItem);
              }
            }
          });
        });

        return Object.values(menuList);
      };

      organizedData.Dashboard = processMenuData(1); // Dashboard
      organizedData.Administrator = processMenuData(2); // Administrator
      organizedData.Transaction = processMenuData(3); // Transaction
      organizedData.Reports = processMenuData(4); // Reports

      setBindMenuMasterDatas(organizedData);
      setIsLoading(false);
    };

    getMenuTableDatas();
  }, [selectedRole]);

  const handleUpdateMenuData = (updatedData) => {
    setBindMenuMasterDatas(updatedData);
  };



  const handleRoleVsCapabilityExport = async () => {
    debugger
    console.log(selectedRole)
    try {
      if (!bindMenuMasterDatas || bindMenuMasterDatas.length === 0) {
        toast.error("No data available for export", {
          duration: 1000,
          position: "top-center",
        });
        return;
      }
      const filteredData = bindRoleDD.filter(
        (item) => item.value === parseInt(selectedRole)
      );

      setSelectedRoleName(filteredData[0].label)

      const headers = roleVsCapabilityExcelHeader.map(
        (column) => column.title
      );

      await roleVsCapabilityExcel(headers, bindMenuMasterDatas);

      toast.success("Role Vs Capability exported successfully", {
        duration: 1000,
        position: "top-center",
      });
    } catch (error) {
      console.error("Role Vs Capability Excel Export Error:", error);

      toast.error("Failed to export Role Vs Capability data", {
        duration: 1000,
        position: "top-center",
      });
    }
  };


  const roleVsCapabilityExcelHeader = [
    { title: "S.No" },
    { title: "Menus" },
    { title: "Add" },
    { title: "View" },
    { title: "Edit" },
    { title: "Delete" },
    { title: "Inactive" },
  ];

  const roleVsCapabilityExcel = (columns, menuData) => {
    const wsData = [];

    /* =========================================
       TITLE
    ========================================= */

    wsData.push([
      {
        v: "Role Vs Capability",
        s: {
          font: {
            bold: true,
            sz: 18,
            color: { rgb: "FFFFFF" },
          },
          fill: {
            fgColor: { rgb: "2D2D6E" },
          },
          alignment: {
            horizontal: "center",
            vertical: "center",
          },
        },
      },
    ]);


    wsData.push([
      {
        v: `Role Vs Capability - ${selectedRoleName || "-"}`,
        s: {
          font: {
            bold: true,
            sz: 12,
            color: { rgb: "000000" },
          },
          alignment: {
            horizontal: "left",
            vertical: "center",
          },
        },
      },
    ]);

    wsData.push([""]);

    let sNo = 1;

    /* =========================================
       LOOP MAIN HEADINGS
    ========================================= */

    Object.keys(menuData).forEach((headingName) => {
      // ===== MAIN HEADING =====
      wsData.push([
        {
          v: headingName,
          s: {
            font: {
              bold: true,
              sz: 14,
              color: { rgb: "FFFFFF" },
            },
            fill: {
              fgColor: {
                rgb:
                  headingName === "Organization Structure"
                    ? "1F1F6E"
                    : "A9A3A3",
              },
            },
            alignment: {
              horizontal: "left",
              vertical: "center",
            },
          },
        },
      ]);

      // ===== COLUMN HEADER =====
      wsData.push([
        {
          v: "S.No",
          s: headerStyle(),
        },
        {
          v: "Menus",
          s: headerStyle(),
        },
        {
          v: "Add",
          s: headerStyle(),
        },
        {
          v: "View",
          s: headerStyle(),
        },
        {
          v: "Edit",
          s: headerStyle(),
        },
        {
          v: "Delete",
          s: headerStyle(),
        },
        {
          v: "Inactive",
          s: headerStyle(),
        },
      ]);

      /* =========================================
         MAIN MENUS + SUBMENUS
      ========================================= */

      menuData[headingName].forEach((item) => {
        // ===== MAIN MENU =====
        wsData.push([
          {
            v: sNo++,
            s: bodyCenterStyle(),
          },

          {
            v: item.MenuName || "-",
            s: bodyLeftBoldStyle(),
          },

          {
            v:
              item.Add === 1 ||
                item.Add === "1"
                ? "Yes"
                : "No",
            s: bodyCenterStyle(),
          },

          {
            v:
              item.View === 1 ||
                item.View === "1"
                ? "Yes"
                : "No",
            s: bodyCenterStyle(),
          },

          {
            v:
              item.Edit === 1 ||
                item.Edit === "1"
                ? "Yes"
                : "No",
            s: bodyCenterStyle(),
          },

          {
            v:
              item.Delete === 1 ||
                item.Delete === "1"
                ? "Yes"
                : "No",
            s: bodyCenterStyle(),
          },

          {
            v:
              item.Inactive === 1 ||
                item.Inactive === "1"
                ? "Yes"
                : "No",
            s: bodyCenterStyle(),
          },
        ]);

        /* =========================================
           SUB MENUS
        ========================================= */

        if (item.SubMenu && item.SubMenu.length > 0) {
          item.SubMenu.forEach((subItem) => {
            wsData.push([
              {
                v: sNo++,
                s: bodyCenterStyle(),
              },

              {
                v:
                  subItem.SubMenu ||
                  subItem.MenuName ||
                  subItem.SubMenuName ||
                  subItem.Name ||
                  "-",
                s: bodyLeftStyle(),
              },

              {
                v:
                  subItem.Add === 1 ||
                    subItem.Add === "1"
                    ? "Yes"
                    : "No",
                s: bodyCenterStyle(),
              },

              {
                v:
                  subItem.View === 1 ||
                    subItem.View === "1"
                    ? "Yes"
                    : "No",
                s: bodyCenterStyle(),
              },

              {
                v:
                  subItem.Edit === 1 ||
                    subItem.Edit === "1"
                    ? "Yes"
                    : "No",
                s: bodyCenterStyle(),
              },

              {
                v:
                  subItem.Delete === 1 ||
                    subItem.Delete === "1"
                    ? "Yes"
                    : "No",
                s: bodyCenterStyle(),
              },

              {
                v:
                  subItem.Inactive === 1 ||
                    subItem.Inactive === "1"
                    ? "Yes"
                    : "No",
                s: bodyCenterStyle(),
              },
            ]);
          });
        }
      });

      wsData.push([""]);
    });

    /* =========================================
       CREATE SHEET
    ========================================= */

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    /* =========================================
       MERGES
    ========================================= */

    const merges = [];

    merges.push({
      s: { r: 0, c: 0 },
      e: { r: 0, c: 6 },
    });
    merges.push({
      s: { r: 1, c: 0 },
      e: { r: 1, c: 6 },
    });
    let rowIndex = 3;

    Object.keys(menuData).forEach((headingName) => {
      merges.push({
        s: { r: rowIndex, c: 0 },
        e: { r: rowIndex, c: 6 },
      });

      let totalRows = 0;

      menuData[headingName].forEach((item) => {
        totalRows += 1;

        if (item.SubMenu && item.SubMenu.length > 0) {
          totalRows += item.SubMenu.length;
        }
      });

      rowIndex += totalRows + 3;
    });

    ws["!merges"] = merges;

    /* =========================================
       COLUMN WIDTHS
    ========================================= */

    ws["!cols"] = [
      { width: 10 },
      { width: 45 },
      { width: 12 },
      { width: 12 },
      { width: 12 },
      { width: 12 },
      { width: 15 },
    ];

    /* =========================================
       ROW HEIGHTS
    ========================================= */

    ws["!rows"] = wsData.map(() => ({
      hpt: 22,
    }));

    /* =========================================
       BORDERS
    ========================================= */

    const range = XLSX.utils.decode_range(ws["!ref"]);

    for (let R = range.s.r; R <= range.e.r; R++) {
      for (let C = range.s.c; C <= range.e.c; C++) {
        const cellRef = XLSX.utils.encode_cell({
          r: R,
          c: C,
        });

        if (!ws[cellRef]) continue;

        ws[cellRef].s = {
          ...ws[cellRef].s,
          border: {
            top: {
              style: "thin",
              color: { rgb: "BFBFBF" },
            },
            bottom: {
              style: "thin",
              color: { rgb: "BFBFBF" },
            },
            left: {
              style: "thin",
              color: { rgb: "BFBFBF" },
            },
            right: {
              style: "thin",
              color: { rgb: "BFBFBF" },
            },
          },
        };
      }
    }

    /* =========================================
       EXPORT
    ========================================= */

    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      wb,
      ws,
      "Role Vs Capability"
    );

    XLSX.writeFile(
      wb,
      "Role_Vs_Capability.xlsx"
    );

    // toast.success("Excel exported successfully 👍", {
    //   duration: 1000,
    //   position: "top-center",
    // });
  };

  /* =========================================
     COMMON STYLES
  ========================================= */

  const headerStyle = () => ({
    font: {
      bold: true,
      color: { rgb: "FFFFFF" },
    },
    fill: {
      fgColor: { rgb: "4F81BD" },
    },
    alignment: {
      horizontal: "center",
      vertical: "center",
    },
  });

  const bodyCenterStyle = () => ({
    alignment: {
      horizontal: "center",
      vertical: "center",
    },
  });

  const bodyLeftStyle = () => ({
    alignment: {
      horizontal: "left",
      vertical: "center",
    },
  });

  const bodyLeftBoldStyle = () => ({
    font: {
      bold: true,
    },
    alignment: {
      horizontal: "left",
      vertical: "center",
    },
  });

  return (
    <div className="RoleVsCapability">
      <RoleVsCapabilityTable
        menuData={bindMenuMasterDatas}
        handleChange={handleUpdateMenuData}
        handleRoleChange={setSelectedRole}
        isLoadings={isLoading}
        handleExportBtn={handleRoleVsCapabilityExport}
      />
    </div>
  );
};

export default RoleVsCapabilityTwo;
